export const refPageModal = "refPageModal";
export const refPageRoute = "refPageRoute";
// export const platformFee=1;
export const menuselection_varitaion = "variation-menu";
export const menuselection_cutomize = "cutomize-menu";
export const menuselection_meal = "meal-menu";
export const menuselection_addon = "meal-adon";


export const device_types_list={
  web:'web'
}


export const store_minimum_delivery_fees_type={
 radios :'RADIOUS',
  area :'AREA'
}

export const payment_type_cash = "cash";
export const payment_type_upi = "upi";
export const payment_type_card = "card";

export const tax_inclusive_type = "inclusive";

export const percentage_value_type = "percentage";
export const fixed_value_type = "fixed";

export const promotion_type = {
  discount: "discount",
};
export const source_type_list = {
  item: "item",
  category: "category",
  cart_value: "cart_value",
  sub_category: "sub_category",
};

export const couponDetails = {
  type: percentage_value_type,
  value: 10, // 10%
  label: "Apply 10% Discount",
};

export const sessionStorage_keys={
  "isSidebarClicking":"isSidebarClicking"
}



export const HEADER_MENU_1=["/checkout","/review" ]
export const HEADER_MENU_2=[ "/login", "/register","/verify-otp","/checkout" ]